import { Row } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { setMobileMenu } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import PersonalInformation from "./PersonalInformation";
import UserContactProfile from "./UserContactProfile";

const Contact = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="contact-sub-content">
      <a className="icon-btn btn-outline-primary button-effect mobile-back mb-3" href={Href} onClick={() => dispatch(setMobileMenu())}>
        <i className="ti-angle-left" />
      </a>
      <Row>
        <UserContactProfile />
        <PersonalInformation />
      </Row>
    </div>
  );
};

export default Contact;
